import React, {Component} from 'react';
import {graphql} from 'react-relay';
import NpsByDeviceTagChart from '../../../../components/NpsByDeviceTagChart';
import withWidgetHeaderAndFooter from '../../../../components/withWidgetHeaderAndFooter';
import withWidgetData from '../../../../components/withWidgetData';
import withReportFilterProps from '../../../../components/withReportFilterProps';
import notifyPhantomWhenMounted from '../../../../components/notifyPhantomWhenMounted';
import withQueryStringProps from '../../../../components/withQueryStringProps';

@withQueryStringProps(['selectedTags'])
@withReportFilterProps
@withWidgetData(
  graphql`
    query NpsByDeviceTagWidgetQuery(
      $widgetId: ID!
      $from: String!
      $to: String!
      $deviceIds: [ID]!
      $filterComments: Boolean!
      $demoData: Boolean!
      $questionFilters: [QuestionFilterInput]
      $aggregateQuestions: [ID]
    ) {
      widget(id: $widgetId) {
        id
        name
        config {
          subtitle
          hideHeader
          question {
            text {
              language
              text
            }
            answersReport(
              from: $from
              to: $to
              deviceIds: $deviceIds
              filterComments: $filterComments
              demoData: $demoData
              questionFilters: $questionFilters
              aggregateQuestions: $aggregateQuestions
            ) {
              count
              ...NpsByDeviceTagChart_answersReport
            }
          }
        }
      }
    }
  `,
)
@notifyPhantomWhenMounted()
@withWidgetHeaderAndFooter({subtitleMessageId: 'npsByDeviceTag'})
class NpsByDeviceTagWidget extends Component {

  render() {
    const { selectedTags } = this.props;
    const widget = this.props.widget;
    const question = widget.config.question;

    return (
      <NpsByDeviceTagChart
        tagsToShow={selectedTags}
        answersReport={question.answersReport}
        height={this.props.bodyHeight}
        width={this.props.width}
        uniqueId={widget.id}
      />
    );
  }
}

export default NpsByDeviceTagWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/NpsByDeviceTagWidget/NpsByDeviceTagWidget.js